import { defineStore } from "pinia";
import type GatheringFeedPublic from "~/pages/gathering/feed/gathering-feed-public.dto";

export const useGatheringFeedListStore = defineStore("gatheringFeedList", {
  state: () => ({
    list: [] as GatheringFeedPublic[],
    fetchedAll: false,
    offset: 0,
  }),
  actions: {
    add(list: GatheringFeedPublic[]) {
      const idSet = new Set(this.list.map((g) => g.id));
      list = list.filter((g) => !idSet.has(g.id));
      this.list = [...this.list, ...list];
    },
    clear() {
      this.list = [];
      this.fetchedAll = false;
      this.offset = 0;
    },
    setFetchedAll(fetchedAll: boolean) {
      this.fetchedAll = fetchedAll;
    },
    setOffset(offset: number) {
      this.offset = offset;
    },
  },
  getters: {
    getList: (state) => [...state.list],
  },
});
